import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/close.png'


const _withScopeId = n => (_pushScopeId("data-v-0b245fd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "file-progress-wrap"
}
const _hoisted_2 = { class: "file-progress-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file-progress-text-box" }, "文件上传中", -1))
const _hoisted_4 = { class: "file-progress-inner-box" }
const _hoisted_5 = {
  key: 1,
  class: "file-show-box"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, "点击或拖拽文件上传，仅支持exe格式文件 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ui-upload-box",
    style: _normalizeStyle(_ctx.style)
  }, [
    (_ctx.uploading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.$slots.progress)
            ? _renderSlot(_ctx.$slots, "progress", {
                key: 0,
                data: _ctx.loaded
              }, undefined, true)
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      style: _normalizeStyle(_ctx.processStyle)
                    }, null, 4)
                  ])
                ])
              ]))
        ], 64))
      : (_ctx.fileName)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.$slots.file)
              ? _renderSlot(_ctx.$slots, "file", { key: 0 }, undefined, true)
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: _ctx.imgSrc,
                    class: "cover-image-box"
                  }, null, 8, _hoisted_6),
                  _createElementVNode("div", {
                    class: "close-btn-box",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeEvent && _ctx.closeEvent(...args)))
                  }, _hoisted_8)
                ]))
          ], 64))
        : (_openBlock(), _createBlock(_component_el_upload, _mergeProps({
            key: 2,
            class: "upload-trigger-box",
            drag: ""
          }, _ctx.$attrs, {
            limit: 1,
            "http-request": _ctx.requests
          }), {
            default: _withCtx(() => [
              (_ctx.$slots.default)
                ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_upload_filled)
                      ]),
                      _: 1
                    }),
                    _hoisted_9
                  ], 64))
            ]),
            _: 3
          }, 16, ["http-request"]))
  ], 4))
}